var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.appErrors.length
    ? _c(
        "div",
        { staticClass: "errors-container" },
        _vm._l(_vm.appErrors, function(error, index) {
          return _c(
            "snackbar",
            {
              key: index,
              attrs: { open: error.open },
              on: {
                closed: function($event) {
                  return _vm.closed(index)
                }
              }
            },
            [_vm._v("\n        " + _vm._s(error.message) + "\n    ")]
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5f746a2", { render: render, staticRenderFns: staticRenderFns })
  }
}